// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Login multi-method verify flow (method list → code entry) */

.lmv-panel {
  width: 100%;
}

.lmv-method-list {
  list-style: none;
  margin: 8px 0 20px;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.lmv-method-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 14px 14px;
  border-radius: 12px;
  border: 1px solid rgba(245, 246, 247, 0.18);
  background: rgba(255, 255, 255, 0.03);
}

body.light_theme .lmv-method-row {
  border-color: #e4e7ec;
  background: #fff;
}

.lmv-method-row.is-done {
  border-color: rgba(34, 197, 94, 0.35);
}

.lmv-method-row__main {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  min-width: 0;
  flex: 1 1;
}

.lmv-method-row__icon {
  width: 36px;
  height: 36px;
  border-radius: 10px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.06);
  color: #d1aa67;
  flex-shrink: 0;
}

body.light_theme .lmv-method-row__icon {
  background: #f5f6f7;
  color: #9a7a2e;
}

.lmv-method-row__icon i {
  font-size: 18px;
}

.lmv-method-row__text {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
}

.lmv-method-row__text strong {
  font-size: 15px;
  font-weight: 600;
  color: #e4e4e4;
}

body.light_theme .lmv-method-row__text strong {
  color: #101828;
}

.lmv-method-row__detail {
  font-size: 12px;
  font-weight: 500;
  color: #8e939c;
  word-break: break-word;
}

.lmv-verify-btn {
  flex-shrink: 0;
  min-width: 72px;
  height: 34px;
  padding: 0 14px;
  border-radius: 999px;
  border: 1px solid #d1aa67;
  background: transparent;
  color: #d1aa67;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
}

.lmv-verify-btn:hover:not(:disabled) {
  background: rgba(209, 170, 103, 0.12);
}

.lmv-verify-btn:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

body.light_theme .lmv-verify-btn {
  border-color: #b8923f;
  color: #9a7a2e;
}

.lmv-check {
  width: 34px;
  height: 34px;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: rgba(34, 197, 94, 0.18);
  color: #22c55e;
  flex-shrink: 0;
}

.lmv-check i {
  font-size: 18px;
  font-weight: 700;
}

.lmv-continue-btn {
  margin-top: 4px;
}

/* Email OTP / Google Authenticator code screen */
.lmv-panel--code {
  display: flex;
  flex-direction: column;
  width: 100%;
}

.lmv-panel--code .login-wizard-title--verify {
  margin: 0 0 8px;
}

.lmv-panel--code .signup-wizard-subtitle {
  margin: 0 0 20px;
  line-height: 1.5;
}

.lmv-panel--code .login-wizard-method-progress {
  list-style: none;
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin: 0 0 24px;
  padding: 0;
}

.form_block_login.login-wizard-root .lmv-panel--code .login-wizard-method-progress li {
  margin: 0;
  padding: 0;
  border: none;
  background: none;
  font-size: inherit;
  font-weight: inherit;
  color: inherit;
}

.lmv-pill-btn {
  border: 1px solid rgba(255, 255, 255, 0.18);
  background: rgba(255, 255, 255, 0.04);
  color: #c9cdd3;
  font: inherit;
  font-size: 13px;
  font-weight: 500;
  padding: 8px 16px;
  border-radius: 999px;
  cursor: pointer;
  outline: none;
  transition: border-color 0.2s ease, color 0.2s ease, background 0.2s ease;
}

.lmv-pill-btn:hover:not(:disabled) {
  border-color: rgba(209, 170, 103, 0.45);
  color: #e4e4e4;
}

.login-wizard-method-progress .is-active .lmv-pill-btn {
  border: 1px solid #d1aa67;
  color: #d1aa67;
  background: rgba(209, 170, 103, 0.1);
}

.login-wizard-method-progress .is-done .lmv-pill-btn {
  border-color: rgba(34, 197, 94, 0.4);
  color: #22c55e;
  background: rgba(34, 197, 94, 0.08);
}

.login-wizard-method-progress .lmv-pill-btn:disabled {
  opacity: 0.65;
  cursor: default;
}

body.light_theme .lmv-pill-btn {
  border-color: #e4e7ec;
  background: #f8fafc;
  color: #475467;
}

body.light_theme .login-wizard-method-progress .is-active .lmv-pill-btn {
  border-color: #b8923f;
  color: #9a7a2e;
  background: #fff8eb;
}

.form_block_login.login-wizard-root .lmv-panel--code .signup-wizard-otp-stack.otp_stack_login,
.lmv-panel--code .signup-wizard-otp-stack.otp_stack_login {
  margin-top: 0;
}

.form_block_login.login-wizard-root .lmv-panel--code .signup-wizard-otp-row,
.lmv-panel--code .signup-wizard-otp-row {
  gap: 12px;
  margin-bottom: 16px;
}

.form_block_login.login-wizard-root .lmv-panel--code .signup-wizard-otp-cell,
.lmv-panel--code .signup-wizard-otp-cell {
  height: 56px;
  max-width: 56px;
  border-radius: 12px;
}

.form_block_login.login-wizard-root .lmv-panel--code .signup-wizard-otp-actions,
.lmv-panel--code .signup-wizard-otp-actions {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0 0 24px;
  min-height: 22px;
}

.lmv-panel--code .signup-wizard-otp-actions.login-otp-actions-paste-only {
  justify-content: space-between;
}

.lmv-otp-actions-spacer {
  display: block;
  min-width: 1px;
}

.lmv-panel--code .lmv-code-submit {
  margin: 0;
}

.form_block_login.login-wizard-root .lmv-panel--code .login-wizard-next-btn {
  margin-top: 0;
}

.lmv-panel--code .signup-wizard-back {
  margin-top: 16px;
  color: #e4e4e4;
}

body.light_theme .lmv-panel--code .signup-wizard-back {
  color: #070808;
}

.lmv-recovery-links {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  margin-top: 8px;
}

.lmv-cant-access {
  display: inline-flex;
  align-items: center;
  margin-top: 12px;
  padding: 0;
  border: 0;
  background: none;
  color: #d1aa67;
  font-size: 14px;
  font-weight: 500;
  text-decoration: underline;
  cursor: pointer;
}

.lmv-cant-access:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

body.light_theme .lmv-cant-access {
  color: #9a7a2e;
}

.lmv-cant-access:hover:not(:disabled) {
  color: #e8c27a;
}

/* —— Lost-method recovery overlays (select → warn → remaining OTP → success) —— */
.lmv-rec-overlay {
  position: fixed;
  inset: 0;
  z-index: 100000040;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 18px;
  background: rgba(0, 0, 0, 0.55);
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
}

body.light_theme .lmv-rec-overlay {
  background: rgba(255, 255, 255, 0.35);
}

.lmv-rec-modal {
  width: 520px;
  max-width: 92vw;
  max-height: calc(100dvh - 36px);
  overflow: auto;
  position: relative;
  text-align: left;
  border-radius: 20px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  padding: 28px 32px 24px;
  background: #181a20f0;
  box-shadow: 0 30px 60px rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
}

body.light_theme .lmv-rec-modal {
  border: 1px solid #e8e8e8;
  background: rgb(255 255 255 / 88%);
  box-shadow: 0 30px 60px rgba(0, 0, 0, 0.16);
}

.lmv-rec-close {
  position: absolute;
  top: 12px;
  right: 14px;
  width: 34px;
  height: 34px;
  border: none;
  border-radius: 8px;
  background: transparent;
  color: #eaecef;
  font-size: 24px;
  line-height: 1;
  cursor: pointer;
}

body.light_theme .lmv-rec-close {
  color: #111827;
}

.lmv-rec-close:hover {
  background: rgba(255, 255, 255, 0.08);
}

body.light_theme .lmv-rec-close:hover {
  background: rgba(17, 24, 39, 0.06);
}

.lmv-rec-title {
  margin: 4px 0 8px;
  padding-right: 40px;
  font-size: 24px;
  font-weight: 600;
  letter-spacing: -0.45px;
  color: #fff;
}

.lmv-rec-title--center {
  padding-right: 0;
  text-align: center;
}

body.light_theme .lmv-rec-title {
  color: #111827;
}

.lmv-rec-sub {
  margin: 0 0 18px;
  color: #84888c;
  font-size: 14px;
  font-weight: 500;
  line-height: 1.5;
}

.lmv-rec-sub--center {
  text-align: center;
}

body.light_theme .lmv-rec-sub {
  color: #6a7282;
}

.lmv-rec-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-bottom: 20px;
}

.lmv-rec-item {
  width: 100%;
  min-height: 62px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 10px 14px;
  border-radius: 12px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  background: rgba(255, 255, 255, 0.05);
  color: inherit;
  cursor: pointer;
  text-align: left;
}

body.light_theme .lmv-rec-item {
  border: 1px solid #e4e4e4;
  background: #fff;
}

.lmv-rec-item:hover,
.lmv-rec-item.is-selected {
  border-color: rgba(209, 170, 103, 0.55);
}

body.light_theme .lmv-rec-item:hover,
body.light_theme .lmv-rec-item.is-selected {
  border-color: #c4b48a;
}

.lmv-rec-item__left {
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
}

.lmv-rec-item__icon {
  width: 28px;
  height: 28px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.lmv-rec-item__icon img {
  width: 22px;
  height: 22px;
  object-fit: contain;
  filter: invert(1);
}

body.light_theme .lmv-rec-item__icon img {
  filter: invert(0);
}

.lmv-rec-item__text {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.lmv-rec-item__text strong {
  font-size: 16px;
  font-weight: 500;
  color: #fff;
}

body.light_theme .lmv-rec-item__text strong {
  color: #111827;
}

.lmv-rec-item__text span {
  font-size: 12px;
  color: #9ca3af;
}

body.light_theme .lmv-rec-item__text span {
  color: #6b7280;
}

.lmv-rec-check {
  width: 18px;
  height: 18px;
  flex-shrink: 0;
  border-radius: 4px;
  border: 2px solid rgba(255, 255, 255, 0.25);
  position: relative;
}

body.light_theme .lmv-rec-check {
  border-color: #e5e7eb;
}

.lmv-rec-check.is-checked {
  border-color: #d1aa67;
  background: #d1aa67;
}

.lmv-rec-check.is-checked::after {
  content: "";
  position: absolute;
  left: 5px;
  top: 1px;
  width: 5px;
  height: 9px;
  border: solid #181a20;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
}

.lmv-rec-primary {
  width: 100%;
  border: none;
  border-radius: 999px;
  padding: 14px 16px;
  background: #1a1d21;
  color: #fff;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
}

body.light_theme .lmv-rec-primary {
  background: #1a1d21;
  color: #fff;
}

.lmv-rec-primary:hover:not(:disabled) {
  opacity: 0.92;
}

.lmv-rec-primary:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

.lmv-rec-primary.is-enabled:not(:disabled) {
  background: #d1aa67;
  color: #1a1d21;
}

.lmv-rec-primary--inline {
  width: auto;
  min-width: 140px;
  flex: 1 1;
}

.lmv-rec-primary--inline.is-enabled {
  background: #d1aa67;
  color: #1a1d21;
}

.lmv-rec-warn-hero {
  display: flex;
  justify-content: center;
  margin: 8px 0 16px;
}

.lmv-rec-warn-hero img {
  height: 104px;
  width: auto;
}

.lmv-rec-ack {
  display: flex;
  gap: 10px;
  align-items: flex-start;
  margin: 8px 0 22px;
  padding: 18px 14px;
  border-radius: 10px;
  border: 1px solid rgba(228, 228, 228, 0.12);
  background: rgba(255, 255, 255, 0.04);
  color: #d0d0d0;
  font-size: 14px;
  line-height: 1.45;
  cursor: pointer;
}

body.light_theme .lmv-rec-ack {
  background: #fff;
  border: 1px solid #e4e4e4;
  color: #374151;
}

.lmv-rec-ack__input {
  position: absolute;
  opacity: 0;
  pointer-events: none;
}

.lmv-rec-ack__box {
  width: 18px;
  height: 18px;
  flex: 0 0 auto;
  margin-top: 2px;
  border-radius: 4px;
  border: 2px solid #e5e7eb;
  background: rgba(255, 255, 255, 0.12);
  position: relative;
}

.lmv-rec-ack__box.is-checked {
  border-color: #d1aa67;
  background: #d1aa67;
}

.lmv-rec-ack__box.is-checked::after {
  content: "";
  position: absolute;
  left: 5px;
  top: 1px;
  width: 5px;
  height: 9px;
  border: solid #181a20;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
}

.lmv-rec-actions {
  display: flex;
  gap: 12px;
}

.lmv-rec-ghost {
  flex: 1 1;
  min-width: 140px;
  border-radius: 999px;
  border: 1px solid rgba(255, 255, 255, 0.18);
  background: transparent;
  color: #fff;
  font-size: 16px;
  font-weight: 500;
  padding: 14px 16px;
  cursor: pointer;
}

body.light_theme .lmv-rec-ghost {
  border-color: #e4e4e4;
  color: #111827;
}

.lmv-rec-field-label {
  margin: 4px 0 8px;
  font-size: 14px;
  font-weight: 500;
  color: #9ca3af;
}

body.light_theme .lmv-rec-field-label {
  color: #303236;
}

.lmv-rec-input-row {
  position: relative;
  margin-bottom: 20px;
}

.lmv-rec-input-row input {
  width: 100%;
  height: 50px;
  box-sizing: border-box;
  border-radius: 12px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  background: rgba(255, 255, 255, 0.05);
  padding: 0 96px 0 14px;
  font-size: 16px;
  letter-spacing: 0.2em;
  color: #fff;
  outline: none;
}

body.light_theme .lmv-rec-input-row input {
  border: 1px solid #e5e7eb;
  background: #fff;
  color: #111827;
}

.lmv-rec-input-row input:focus {
  border-color: #d1aa67;
  box-shadow: 0 0 0 2px rgba(209, 170, 103, 0.18);
}

.lmv-rec-input-action {
  position: absolute;
  top: 50%;
  right: 10px;
  transform: translateY(-50%);
  border: none;
  background: none;
  color: #d1aa67;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  padding: 6px 4px;
}

.lmv-rec-input-action:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

.lmv-rec-footer {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin-top: 16px;
  color: #84888c;
  font-size: 12px;
}

.lmv-rec-footer img {
  width: 16px;
  height: 16px;
}

.lmv-rec-success-hero {
  display: flex;
  justify-content: center;
  margin: 12px 0 16px;
}

.lmv-rec-success-hero img {
  width: 88px;
  height: auto;
}

.lmv-rec-req-topbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: -8px 0 12px;
}

.lmv-rec-back {
  width: 34px;
  height: 34px;
  border: none;
  border-radius: 8px;
  background: transparent;
  color: #eaecef;
  font-size: 20px;
  cursor: pointer;
}

body.light_theme .lmv-rec-back {
  color: #111827;
}

.lmv-rec-close--inline {
  position: static;
}

.lmv-rec-req-progress {
  font-size: 24px;
  font-weight: 600;
  color: #d1aa67;
  margin: 8px 0 16px;
}

.lmv-rec-req-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.lmv-rec-req-item {
  width: 100%;
  min-height: 62px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 10px 14px;
  border-radius: 12px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  background: rgba(255, 255, 255, 0.05);
  color: inherit;
  cursor: pointer;
  text-align: left;
}

body.light_theme .lmv-rec-req-item {
  border: 1px solid #e4e4e4;
  background: #fff;
}

.lmv-rec-req-item:hover:not(:disabled) {
  border-color: rgba(209, 170, 103, 0.55);
}

.lmv-rec-req-item.is-done,
.lmv-rec-req-item:disabled {
  cursor: default;
  opacity: 0.9;
}

.lmv-rec-req-right {
  color: #9ca3af;
  font-size: 20px;
  line-height: 1;
}

.lmv-rec-req-item.is-done .lmv-rec-req-right {
  color: #22c55e;
}

.lmv-rec-modal--success .lmv-rec-title,
.lmv-rec-modal--warn .lmv-rec-title {
  padding-right: 40px;
}

.lmv-rec-modal--success .lmv-rec-title--center,
.lmv-rec-modal--warn .lmv-rec-title--center {
  padding-right: 40px;
}

@media (max-width: 575px) {
  .lmv-rec-modal {
    padding: 22px 18px 18px;
    border-radius: 16px;
  }

  .lmv-rec-title {
    font-size: 20px;
  }

  .lmv-rec-actions {
    flex-direction: column;
  }

  .lmv-rec-ghost,
  .lmv-rec-primary--inline {
    width: 100%;
  }
}

@media (max-width: 575px) {
  .lmv-method-row {
    padding: 12px;
  }

  .lmv-verify-btn {
    min-width: 64px;
    height: 32px;
    font-size: 12px;
  }

  .lmv-panel--code .login-wizard-method-progress {
    margin-bottom: 20px;
    gap: 8px;
  }

  .lmv-panel--code .signup-wizard-otp-row,
  .form_block_login.login-wizard-root .lmv-panel--code .signup-wizard-otp-row {
    gap: 8px;
    margin-bottom: 14px;
  }

  .lmv-panel--code .signup-wizard-otp-cell,
  .form_block_login.login-wizard-root .lmv-panel--code .signup-wizard-otp-cell {
    height: 48px;
    max-width: none;
  }

  .lmv-panel--code .signup-wizard-otp-actions {
    margin-bottom: 20px;
  }

  .lmv-panel--code .signup-wizard-back {
    margin-top: 14px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/ui/Pages/LoginPage/components/loginVerifyFlow.css"],"names":[],"mappings":"AAAA,8DAA8D;;AAE9D;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,2CAA2C;EAC3C,qCAAqC;AACvC;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,YAAY;EACZ,SAAO;AACT;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,qCAAqC;EACrC,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,YAAY;EACZ,eAAe;EACf,oBAAoB;EACpB,yBAAyB;EACzB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,mCAAmC;EACnC,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA,iDAAiD;AACjD;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,eAAe;EACf,SAAS;EACT,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,SAAS;EACT,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,2CAA2C;EAC3C,qCAAqC;EACrC,cAAc;EACd,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;EACpB,eAAe;EACf,aAAa;EACb,yEAAyE;AAC3E;;AAEA;EACE,uCAAuC;EACvC,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;EACpC,cAAc;EACd,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,mBAAmB;AACrB;;AAEA;;EAEE,aAAa;AACf;;AAEA;;EAEE,SAAS;EACT,mBAAmB;AACrB;;AAEA;;EAEE,YAAY;EACZ,eAAe;EACf,mBAAmB;AACrB;;AAEA;;EAEE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,kFAAkF;AAClF;EACE,eAAe;EACf,QAAQ;EACR,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,+BAA+B;EAC/B,0BAA0B;EAC1B,kCAAkC;AACpC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,+BAA+B;EAC/B,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,0CAA0C;EAC1C,uBAAuB;EACvB,qBAAqB;EACrB,0CAA0C;EAC1C,0BAA0B;EAC1B,kCAAkC;AACpC;;AAEA;EACE,yBAAyB;EACzB,kCAAkC;EAClC,2CAA2C;AAC7C;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,0CAA0C;EAC1C,qCAAqC;EACrC,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;;EAEE,uCAAuC;AACzC;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,2CAA2C;EAC3C,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,UAAU;EACV,WAAW;EACX,qBAAqB;EACrB,yBAAyB;EACzB,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,SAAO;AACT;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,2CAA2C;EAC3C,qCAAqC;EACrC,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,yBAAyB;EACzB,qCAAqC;EACrC,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,UAAU;EACV,WAAW;EACX,qBAAqB;EACrB,yBAAyB;EACzB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,oBAAoB;EACpB,2CAA2C;EAC3C,uBAAuB;EACvB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,mBAAmB;EACnB,0CAA0C;EAC1C,qCAAqC;EACrC,sBAAsB;EACtB,eAAe;EACf,qBAAqB;EACrB,WAAW;EACX,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,+CAA+C;AACjD;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,2BAA2B;EAC3B,YAAY;EACZ,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,0CAA0C;EAC1C,qCAAqC;EACrC,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,uCAAuC;AACzC;;AAEA;;EAEE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE;IACE,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;;IAEE,WAAW;EACb;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,eAAe;IACf,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,mBAAmB;IACnB,QAAQ;EACV;;EAEA;;IAEE,QAAQ;IACR,mBAAmB;EACrB;;EAEA;;IAEE,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;EAClB;AACF","sourcesContent":["/* Login multi-method verify flow (method list → code entry) */\n\n.lmv-panel {\n  width: 100%;\n}\n\n.lmv-method-list {\n  list-style: none;\n  margin: 8px 0 20px;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.lmv-method-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 14px 14px;\n  border-radius: 12px;\n  border: 1px solid rgba(245, 246, 247, 0.18);\n  background: rgba(255, 255, 255, 0.03);\n}\n\nbody.light_theme .lmv-method-row {\n  border-color: #e4e7ec;\n  background: #fff;\n}\n\n.lmv-method-row.is-done {\n  border-color: rgba(34, 197, 94, 0.35);\n}\n\n.lmv-method-row__main {\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n  min-width: 0;\n  flex: 1;\n}\n\n.lmv-method-row__icon {\n  width: 36px;\n  height: 36px;\n  border-radius: 10px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  background: rgba(255, 255, 255, 0.06);\n  color: #d1aa67;\n  flex-shrink: 0;\n}\n\nbody.light_theme .lmv-method-row__icon {\n  background: #f5f6f7;\n  color: #9a7a2e;\n}\n\n.lmv-method-row__icon i {\n  font-size: 18px;\n}\n\n.lmv-method-row__text {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  min-width: 0;\n}\n\n.lmv-method-row__text strong {\n  font-size: 15px;\n  font-weight: 600;\n  color: #e4e4e4;\n}\n\nbody.light_theme .lmv-method-row__text strong {\n  color: #101828;\n}\n\n.lmv-method-row__detail {\n  font-size: 12px;\n  font-weight: 500;\n  color: #8e939c;\n  word-break: break-word;\n}\n\n.lmv-verify-btn {\n  flex-shrink: 0;\n  min-width: 72px;\n  height: 34px;\n  padding: 0 14px;\n  border-radius: 999px;\n  border: 1px solid #d1aa67;\n  background: transparent;\n  color: #d1aa67;\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.lmv-verify-btn:hover:not(:disabled) {\n  background: rgba(209, 170, 103, 0.12);\n}\n\n.lmv-verify-btn:disabled {\n  opacity: 0.55;\n  cursor: not-allowed;\n}\n\nbody.light_theme .lmv-verify-btn {\n  border-color: #b8923f;\n  color: #9a7a2e;\n}\n\n.lmv-check {\n  width: 34px;\n  height: 34px;\n  border-radius: 50%;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  background: rgba(34, 197, 94, 0.18);\n  color: #22c55e;\n  flex-shrink: 0;\n}\n\n.lmv-check i {\n  font-size: 18px;\n  font-weight: 700;\n}\n\n.lmv-continue-btn {\n  margin-top: 4px;\n}\n\n/* Email OTP / Google Authenticator code screen */\n.lmv-panel--code {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n}\n\n.lmv-panel--code .login-wizard-title--verify {\n  margin: 0 0 8px;\n}\n\n.lmv-panel--code .signup-wizard-subtitle {\n  margin: 0 0 20px;\n  line-height: 1.5;\n}\n\n.lmv-panel--code .login-wizard-method-progress {\n  list-style: none;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n  margin: 0 0 24px;\n  padding: 0;\n}\n\n.form_block_login.login-wizard-root .lmv-panel--code .login-wizard-method-progress li {\n  margin: 0;\n  padding: 0;\n  border: none;\n  background: none;\n  font-size: inherit;\n  font-weight: inherit;\n  color: inherit;\n}\n\n.lmv-pill-btn {\n  border: 1px solid rgba(255, 255, 255, 0.18);\n  background: rgba(255, 255, 255, 0.04);\n  color: #c9cdd3;\n  font: inherit;\n  font-size: 13px;\n  font-weight: 500;\n  padding: 8px 16px;\n  border-radius: 999px;\n  cursor: pointer;\n  outline: none;\n  transition: border-color 0.2s ease, color 0.2s ease, background 0.2s ease;\n}\n\n.lmv-pill-btn:hover:not(:disabled) {\n  border-color: rgba(209, 170, 103, 0.45);\n  color: #e4e4e4;\n}\n\n.login-wizard-method-progress .is-active .lmv-pill-btn {\n  border: 1px solid #d1aa67;\n  color: #d1aa67;\n  background: rgba(209, 170, 103, 0.1);\n}\n\n.login-wizard-method-progress .is-done .lmv-pill-btn {\n  border-color: rgba(34, 197, 94, 0.4);\n  color: #22c55e;\n  background: rgba(34, 197, 94, 0.08);\n}\n\n.login-wizard-method-progress .lmv-pill-btn:disabled {\n  opacity: 0.65;\n  cursor: default;\n}\n\nbody.light_theme .lmv-pill-btn {\n  border-color: #e4e7ec;\n  background: #f8fafc;\n  color: #475467;\n}\n\nbody.light_theme .login-wizard-method-progress .is-active .lmv-pill-btn {\n  border-color: #b8923f;\n  color: #9a7a2e;\n  background: #fff8eb;\n}\n\n.form_block_login.login-wizard-root .lmv-panel--code .signup-wizard-otp-stack.otp_stack_login,\n.lmv-panel--code .signup-wizard-otp-stack.otp_stack_login {\n  margin-top: 0;\n}\n\n.form_block_login.login-wizard-root .lmv-panel--code .signup-wizard-otp-row,\n.lmv-panel--code .signup-wizard-otp-row {\n  gap: 12px;\n  margin-bottom: 16px;\n}\n\n.form_block_login.login-wizard-root .lmv-panel--code .signup-wizard-otp-cell,\n.lmv-panel--code .signup-wizard-otp-cell {\n  height: 56px;\n  max-width: 56px;\n  border-radius: 12px;\n}\n\n.form_block_login.login-wizard-root .lmv-panel--code .signup-wizard-otp-actions,\n.lmv-panel--code .signup-wizard-otp-actions {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin: 0 0 24px;\n  min-height: 22px;\n}\n\n.lmv-panel--code .signup-wizard-otp-actions.login-otp-actions-paste-only {\n  justify-content: space-between;\n}\n\n.lmv-otp-actions-spacer {\n  display: block;\n  min-width: 1px;\n}\n\n.lmv-panel--code .lmv-code-submit {\n  margin: 0;\n}\n\n.form_block_login.login-wizard-root .lmv-panel--code .login-wizard-next-btn {\n  margin-top: 0;\n}\n\n.lmv-panel--code .signup-wizard-back {\n  margin-top: 16px;\n  color: #e4e4e4;\n}\n\nbody.light_theme .lmv-panel--code .signup-wizard-back {\n  color: #070808;\n}\n\n.lmv-recovery-links {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 8px;\n  margin-top: 8px;\n}\n\n.lmv-cant-access {\n  display: inline-flex;\n  align-items: center;\n  margin-top: 12px;\n  padding: 0;\n  border: 0;\n  background: none;\n  color: #d1aa67;\n  font-size: 14px;\n  font-weight: 500;\n  text-decoration: underline;\n  cursor: pointer;\n}\n\n.lmv-cant-access:disabled {\n  opacity: 0.55;\n  cursor: not-allowed;\n}\n\nbody.light_theme .lmv-cant-access {\n  color: #9a7a2e;\n}\n\n.lmv-cant-access:hover:not(:disabled) {\n  color: #e8c27a;\n}\n\n/* —— Lost-method recovery overlays (select → warn → remaining OTP → success) —— */\n.lmv-rec-overlay {\n  position: fixed;\n  inset: 0;\n  z-index: 100000040;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 18px;\n  background: rgba(0, 0, 0, 0.55);\n  backdrop-filter: blur(8px);\n  -webkit-backdrop-filter: blur(8px);\n}\n\nbody.light_theme .lmv-rec-overlay {\n  background: rgba(255, 255, 255, 0.35);\n}\n\n.lmv-rec-modal {\n  width: 520px;\n  max-width: 92vw;\n  max-height: calc(100dvh - 36px);\n  overflow: auto;\n  position: relative;\n  text-align: left;\n  border-radius: 20px;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  padding: 28px 32px 24px;\n  background: #181a20f0;\n  box-shadow: 0 30px 60px rgba(0, 0, 0, 0.5);\n  backdrop-filter: blur(8px);\n  -webkit-backdrop-filter: blur(8px);\n}\n\nbody.light_theme .lmv-rec-modal {\n  border: 1px solid #e8e8e8;\n  background: rgb(255 255 255 / 88%);\n  box-shadow: 0 30px 60px rgba(0, 0, 0, 0.16);\n}\n\n.lmv-rec-close {\n  position: absolute;\n  top: 12px;\n  right: 14px;\n  width: 34px;\n  height: 34px;\n  border: none;\n  border-radius: 8px;\n  background: transparent;\n  color: #eaecef;\n  font-size: 24px;\n  line-height: 1;\n  cursor: pointer;\n}\n\nbody.light_theme .lmv-rec-close {\n  color: #111827;\n}\n\n.lmv-rec-close:hover {\n  background: rgba(255, 255, 255, 0.08);\n}\n\nbody.light_theme .lmv-rec-close:hover {\n  background: rgba(17, 24, 39, 0.06);\n}\n\n.lmv-rec-title {\n  margin: 4px 0 8px;\n  padding-right: 40px;\n  font-size: 24px;\n  font-weight: 600;\n  letter-spacing: -0.45px;\n  color: #fff;\n}\n\n.lmv-rec-title--center {\n  padding-right: 0;\n  text-align: center;\n}\n\nbody.light_theme .lmv-rec-title {\n  color: #111827;\n}\n\n.lmv-rec-sub {\n  margin: 0 0 18px;\n  color: #84888c;\n  font-size: 14px;\n  font-weight: 500;\n  line-height: 1.5;\n}\n\n.lmv-rec-sub--center {\n  text-align: center;\n}\n\nbody.light_theme .lmv-rec-sub {\n  color: #6a7282;\n}\n\n.lmv-rec-list {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  margin-bottom: 20px;\n}\n\n.lmv-rec-item {\n  width: 100%;\n  min-height: 62px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 10px 14px;\n  border-radius: 12px;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  background: rgba(255, 255, 255, 0.05);\n  color: inherit;\n  cursor: pointer;\n  text-align: left;\n}\n\nbody.light_theme .lmv-rec-item {\n  border: 1px solid #e4e4e4;\n  background: #fff;\n}\n\n.lmv-rec-item:hover,\n.lmv-rec-item.is-selected {\n  border-color: rgba(209, 170, 103, 0.55);\n}\n\nbody.light_theme .lmv-rec-item:hover,\nbody.light_theme .lmv-rec-item.is-selected {\n  border-color: #c4b48a;\n}\n\n.lmv-rec-item__left {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  min-width: 0;\n}\n\n.lmv-rec-item__icon {\n  width: 28px;\n  height: 28px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.lmv-rec-item__icon img {\n  width: 22px;\n  height: 22px;\n  object-fit: contain;\n  filter: invert(1);\n}\n\nbody.light_theme .lmv-rec-item__icon img {\n  filter: invert(0);\n}\n\n.lmv-rec-item__text {\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n}\n\n.lmv-rec-item__text strong {\n  font-size: 16px;\n  font-weight: 500;\n  color: #fff;\n}\n\nbody.light_theme .lmv-rec-item__text strong {\n  color: #111827;\n}\n\n.lmv-rec-item__text span {\n  font-size: 12px;\n  color: #9ca3af;\n}\n\nbody.light_theme .lmv-rec-item__text span {\n  color: #6b7280;\n}\n\n.lmv-rec-check {\n  width: 18px;\n  height: 18px;\n  flex-shrink: 0;\n  border-radius: 4px;\n  border: 2px solid rgba(255, 255, 255, 0.25);\n  position: relative;\n}\n\nbody.light_theme .lmv-rec-check {\n  border-color: #e5e7eb;\n}\n\n.lmv-rec-check.is-checked {\n  border-color: #d1aa67;\n  background: #d1aa67;\n}\n\n.lmv-rec-check.is-checked::after {\n  content: \"\";\n  position: absolute;\n  left: 5px;\n  top: 1px;\n  width: 5px;\n  height: 9px;\n  border: solid #181a20;\n  border-width: 0 2px 2px 0;\n  transform: rotate(45deg);\n}\n\n.lmv-rec-primary {\n  width: 100%;\n  border: none;\n  border-radius: 999px;\n  padding: 14px 16px;\n  background: #1a1d21;\n  color: #fff;\n  font-size: 16px;\n  font-weight: 500;\n  cursor: pointer;\n}\n\nbody.light_theme .lmv-rec-primary {\n  background: #1a1d21;\n  color: #fff;\n}\n\n.lmv-rec-primary:hover:not(:disabled) {\n  opacity: 0.92;\n}\n\n.lmv-rec-primary:disabled {\n  opacity: 0.45;\n  cursor: not-allowed;\n}\n\n.lmv-rec-primary.is-enabled:not(:disabled) {\n  background: #d1aa67;\n  color: #1a1d21;\n}\n\n.lmv-rec-primary--inline {\n  width: auto;\n  min-width: 140px;\n  flex: 1;\n}\n\n.lmv-rec-primary--inline.is-enabled {\n  background: #d1aa67;\n  color: #1a1d21;\n}\n\n.lmv-rec-warn-hero {\n  display: flex;\n  justify-content: center;\n  margin: 8px 0 16px;\n}\n\n.lmv-rec-warn-hero img {\n  height: 104px;\n  width: auto;\n}\n\n.lmv-rec-ack {\n  display: flex;\n  gap: 10px;\n  align-items: flex-start;\n  margin: 8px 0 22px;\n  padding: 18px 14px;\n  border-radius: 10px;\n  border: 1px solid rgba(228, 228, 228, 0.12);\n  background: rgba(255, 255, 255, 0.04);\n  color: #d0d0d0;\n  font-size: 14px;\n  line-height: 1.45;\n  cursor: pointer;\n}\n\nbody.light_theme .lmv-rec-ack {\n  background: #fff;\n  border: 1px solid #e4e4e4;\n  color: #374151;\n}\n\n.lmv-rec-ack__input {\n  position: absolute;\n  opacity: 0;\n  pointer-events: none;\n}\n\n.lmv-rec-ack__box {\n  width: 18px;\n  height: 18px;\n  flex: 0 0 auto;\n  margin-top: 2px;\n  border-radius: 4px;\n  border: 2px solid #e5e7eb;\n  background: rgba(255, 255, 255, 0.12);\n  position: relative;\n}\n\n.lmv-rec-ack__box.is-checked {\n  border-color: #d1aa67;\n  background: #d1aa67;\n}\n\n.lmv-rec-ack__box.is-checked::after {\n  content: \"\";\n  position: absolute;\n  left: 5px;\n  top: 1px;\n  width: 5px;\n  height: 9px;\n  border: solid #181a20;\n  border-width: 0 2px 2px 0;\n  transform: rotate(45deg);\n}\n\n.lmv-rec-actions {\n  display: flex;\n  gap: 12px;\n}\n\n.lmv-rec-ghost {\n  flex: 1;\n  min-width: 140px;\n  border-radius: 999px;\n  border: 1px solid rgba(255, 255, 255, 0.18);\n  background: transparent;\n  color: #fff;\n  font-size: 16px;\n  font-weight: 500;\n  padding: 14px 16px;\n  cursor: pointer;\n}\n\nbody.light_theme .lmv-rec-ghost {\n  border-color: #e4e4e4;\n  color: #111827;\n}\n\n.lmv-rec-field-label {\n  margin: 4px 0 8px;\n  font-size: 14px;\n  font-weight: 500;\n  color: #9ca3af;\n}\n\nbody.light_theme .lmv-rec-field-label {\n  color: #303236;\n}\n\n.lmv-rec-input-row {\n  position: relative;\n  margin-bottom: 20px;\n}\n\n.lmv-rec-input-row input {\n  width: 100%;\n  height: 50px;\n  box-sizing: border-box;\n  border-radius: 12px;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  background: rgba(255, 255, 255, 0.05);\n  padding: 0 96px 0 14px;\n  font-size: 16px;\n  letter-spacing: 0.2em;\n  color: #fff;\n  outline: none;\n}\n\nbody.light_theme .lmv-rec-input-row input {\n  border: 1px solid #e5e7eb;\n  background: #fff;\n  color: #111827;\n}\n\n.lmv-rec-input-row input:focus {\n  border-color: #d1aa67;\n  box-shadow: 0 0 0 2px rgba(209, 170, 103, 0.18);\n}\n\n.lmv-rec-input-action {\n  position: absolute;\n  top: 50%;\n  right: 10px;\n  transform: translateY(-50%);\n  border: none;\n  background: none;\n  color: #d1aa67;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  padding: 6px 4px;\n}\n\n.lmv-rec-input-action:disabled {\n  opacity: 0.55;\n  cursor: not-allowed;\n}\n\n.lmv-rec-footer {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  margin-top: 16px;\n  color: #84888c;\n  font-size: 12px;\n}\n\n.lmv-rec-footer img {\n  width: 16px;\n  height: 16px;\n}\n\n.lmv-rec-success-hero {\n  display: flex;\n  justify-content: center;\n  margin: 12px 0 16px;\n}\n\n.lmv-rec-success-hero img {\n  width: 88px;\n  height: auto;\n}\n\n.lmv-rec-req-topbar {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin: -8px 0 12px;\n}\n\n.lmv-rec-back {\n  width: 34px;\n  height: 34px;\n  border: none;\n  border-radius: 8px;\n  background: transparent;\n  color: #eaecef;\n  font-size: 20px;\n  cursor: pointer;\n}\n\nbody.light_theme .lmv-rec-back {\n  color: #111827;\n}\n\n.lmv-rec-close--inline {\n  position: static;\n}\n\n.lmv-rec-req-progress {\n  font-size: 24px;\n  font-weight: 600;\n  color: #d1aa67;\n  margin: 8px 0 16px;\n}\n\n.lmv-rec-req-list {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.lmv-rec-req-item {\n  width: 100%;\n  min-height: 62px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 10px 14px;\n  border-radius: 12px;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  background: rgba(255, 255, 255, 0.05);\n  color: inherit;\n  cursor: pointer;\n  text-align: left;\n}\n\nbody.light_theme .lmv-rec-req-item {\n  border: 1px solid #e4e4e4;\n  background: #fff;\n}\n\n.lmv-rec-req-item:hover:not(:disabled) {\n  border-color: rgba(209, 170, 103, 0.55);\n}\n\n.lmv-rec-req-item.is-done,\n.lmv-rec-req-item:disabled {\n  cursor: default;\n  opacity: 0.9;\n}\n\n.lmv-rec-req-right {\n  color: #9ca3af;\n  font-size: 20px;\n  line-height: 1;\n}\n\n.lmv-rec-req-item.is-done .lmv-rec-req-right {\n  color: #22c55e;\n}\n\n.lmv-rec-modal--success .lmv-rec-title,\n.lmv-rec-modal--warn .lmv-rec-title {\n  padding-right: 40px;\n}\n\n.lmv-rec-modal--success .lmv-rec-title--center,\n.lmv-rec-modal--warn .lmv-rec-title--center {\n  padding-right: 40px;\n}\n\n@media (max-width: 575px) {\n  .lmv-rec-modal {\n    padding: 22px 18px 18px;\n    border-radius: 16px;\n  }\n\n  .lmv-rec-title {\n    font-size: 20px;\n  }\n\n  .lmv-rec-actions {\n    flex-direction: column;\n  }\n\n  .lmv-rec-ghost,\n  .lmv-rec-primary--inline {\n    width: 100%;\n  }\n}\n\n@media (max-width: 575px) {\n  .lmv-method-row {\n    padding: 12px;\n  }\n\n  .lmv-verify-btn {\n    min-width: 64px;\n    height: 32px;\n    font-size: 12px;\n  }\n\n  .lmv-panel--code .login-wizard-method-progress {\n    margin-bottom: 20px;\n    gap: 8px;\n  }\n\n  .lmv-panel--code .signup-wizard-otp-row,\n  .form_block_login.login-wizard-root .lmv-panel--code .signup-wizard-otp-row {\n    gap: 8px;\n    margin-bottom: 14px;\n  }\n\n  .lmv-panel--code .signup-wizard-otp-cell,\n  .form_block_login.login-wizard-root .lmv-panel--code .signup-wizard-otp-cell {\n    height: 48px;\n    max-width: none;\n  }\n\n  .lmv-panel--code .signup-wizard-otp-actions {\n    margin-bottom: 20px;\n  }\n\n  .lmv-panel--code .signup-wizard-back {\n    margin-top: 14px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
